import isNil from 'lodash/isNil';

import { RecaptchaDtoType } from './types';

export const RecaptchaDto = (data?: string | null): RecaptchaDtoType => ({
  recaptcha_verify: {
    response: isNil(data) ? '' : data,
  },
});
